<template>
  <div 
    class="item-wrapper" 
    :class="{ 'selected': item?.id === leftNavItem.id }"
    @click="onSelectedNavItem"
  >
    <div
      v-if="!leftNavItem.icon"
      class="icon-box"
    />
    <font-awesome-icon
      v-else
      :icon="['fas', leftNavItem.icon]"
    />
    <span class="item-name">{{ leftNavItem.name }}</span>
    <div 
      :class="{ 'disabled-icon': !leftNavItem.editable }"
      @click="deleteThis"
    >
      <font-awesome-icon 
        class="delete-icon" 
        variant="danger" 
        :icon="['fas', 'trash']" 
      />
    </div>
  </div>
</template>
<script>

import { createNamespacedHelpers } from 'vuex';
import { SELECTED_NAV_ITEM, REMOVE_NAV_ITEM } from '@/store/modules/left-nav-customization/mutation-types';

const { mapMutations, mapState: leftNavCustomizationMapState, mapActions:  leftNavCustomizationMapActions} = createNamespacedHelpers('leftNavCustomization');
export default {
  name: 'Item',
  props: {
    leftNavItem: Object,
  },
  computed: {
    ...leftNavCustomizationMapState({
      item: state => state.selectedNavItem,
      leftNavItems: state => state.leftNavData,
    }),
  },
  methods:{
    ...mapMutations({
      selectedNavItem: SELECTED_NAV_ITEM,
      removeItem: REMOVE_NAV_ITEM,
    }),
    ...leftNavCustomizationMapActions(['setSubItemName']),
    onSelectedNavItem(){
      this.setSubItemName(this.leftNavItem);
    },
    deleteThis(){
      if(!this.leftNavItem.editable)
        return;
      this.removeItem(this.leftNavItem.id);
      this.selectedNavItem(this.leftNavItems[0]);//0 for system module - which will always be there
    },
  },
};
</script>
<style scoped lang="scss">
.item-wrapper {
  cursor: grab;
  background-color: white;
  display: flex;
  align-items: center;
  padding: 6px 10px; /* Reduced left padding */
  border-radius: 4px;
  margin-bottom: 10px;
  border: 1px solid #aeaeae;
  &.selected {
    background: #e0e0e0;
  }
}

.item-icon {
  font-size: 16px;
  margin-right: 8px;
  color: #666;
}

.item-name {
  flex-grow: 1; /* Takes remaining space */
  margin-left: 8px;
}

.delete-icon {
  font-size: 14px;
  color: #d9534f;
  cursor: pointer;
}
.icon-box {
  width: 20px;
  height: 20px;
  background: #ddd;
  border: 1px dashed #aaa;
  display: inline-block;
  vertical-align: middle;
}
.disabled-icon {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>